import React from 'react'

const SvgCalendarTimesOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 2c.667 0 1 .314 1 .941V4h1c1.333 0 2 .667 2 2v8.41l-.707.708-1.21-1.21c-.027-.028-.055-.053-.083-.079V10H6v10h8.41l-.71.71c-.373.373-.63.818-.772 1.29H6c-1.333 0-2-.667-2-2V6.004C4 4.668 4.667 4 6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941zM6 8h12V6H6v2z'
    />
    <path d='M10 16c.667 0 1 .333 1 1s-.333 1-1 1H9c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10zM10 12c.667 0 1 .333 1 1s-.333 1-1 1H9c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10zM15 12c.667 0 1 .333 1 1l-.001.005a3.087 3.087 0 00-2.299.902l-.052.054C13.216 13.857 13 13.538 13 13c0-.668.335-1.001 1.002-1H15z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.81 19.5l-2.71-2.71a1.048 1.048 0 011.482-1.483l2.71 2.71 2.711-2.71a1.048 1.048 0 011.483 1.482l-2.71 2.711 2.71 2.71a1.048 1.048 0 01-1.483 1.483l-2.71-2.71-2.71 2.71A1.048 1.048 0 0115.1 22.21l2.71-2.71z'
    />
  </svg>
)

export default SvgCalendarTimesOutline
